<template>
  <section class="flex flex-col gap-2">
    <transition-group
      name="list"
      tag="div"
      class="flex flex-col gap-2"
    >
      <div
        v-for="(field, index) in fields"
        :key="`${index}-rate-con-${index}-id`"
        class="relative w-full"
      >
        <template v-if="field.type == 'phone'">
          <input
            v-model="field.value"
            v-mask="'###-###-####'"
            :type="getInputType(field.type)"
            class="h-12 w-full rounded border border-transparent bg-off-white p-2 text-sm placeholder-gray-over-dark hover:border-placeholder-gray focus:bg-white focus:text-dark-gray"
            :placeholder="getPlaceholder(field.type)"
          />
        </template>
        <template v-else>
          <input
            v-model="field.value"
            :type="getInputType(field.type)"
            class="h-12 w-full rounded border border-transparent bg-off-white p-2 pl-20 text-sm placeholder-gray-over-dark hover:border-placeholder-gray focus:bg-white focus:text-dark-gray"
            :placeholder="getPlaceholder(field.type)"
          />
        </template>
        <div
          v-if="emailOrDomain"
          class="absolute left-0 top-0 flex h-full items-center pl-2"
        >
          <section class="relative rounded-md border bg-white">
            <span
              class="z-5 absolute bottom-0 top-0 h-8 w-8 rounded-md bg-yellow-500 transition-all duration-200 ease-in-out"
              :style="{
                left: field.type === 'email' ? '0px' : 'calc(100% - 2rem)',
              }"
            />
            <button
              class="relative z-10 rounded-md p-2"
              :class="[
                field.type === 'email' ? 'text-white' : 'text-gray-over-dark',
              ]"
              @click="updateType(index, 'email')"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M2.66536 2.66699H13.332C14.0654 2.66699 14.6654 3.26699 14.6654 4.00033V12.0003C14.6654 12.7337 14.0654 13.3337 13.332 13.3337H2.66536C1.93203 13.3337 1.33203 12.7337 1.33203 12.0003V4.00033C1.33203 3.26699 1.93203 2.66699 2.66536 2.66699Z"
                  stroke="currentColor"
                  stroke-width="1.33333"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M14.6654 4L7.9987 8.66667L1.33203 4"
                  stroke="currentColor"
                  stroke-width="1.33333"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
            <button
              class="relative z-10 rounded-r-md p-2"
              :class="[
                field.type === 'domain' ? 'text-white' : 'text-gray-over-dark',
              ]"
              @click="updateType(index, 'domain')"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <g clip-path="url(#clip0_7142_149278)">
                  <path
                    d="M16 7.37967C15.7662 5.44115 14.8156 3.66024 13.3352 2.38709C11.8548 1.11394 9.95167 0.440673 8 0.499667C6.04833 0.440673 4.14519 1.11394 2.66478 2.38709C1.18438 3.66024 0.233816 5.44115 0 7.37967L0 8.61967C0.233816 10.5582 1.18438 12.3391 2.66478 13.6122C4.14519 14.8854 6.04833 15.5587 8 15.4997C9.95167 15.5587 11.8548 14.8854 13.3352 13.6122C14.8156 12.3391 15.7662 10.5582 16 8.61967V7.37967ZM14.75 7.37967H11.75C11.7036 6.51942 11.5594 5.66725 11.32 4.83967C11.9451 4.58551 12.5337 4.24922 13.07 3.83967C13.9994 4.80263 14.5802 6.04867 14.72 7.37967H14.75ZM5.57 7.37967C5.61275 6.65472 5.73687 5.93688 5.94 5.23967C6.61333 5.41089 7.30524 5.49822 8 5.49967C8.70476 5.50008 9.40683 5.41274 10.09 5.23967C10.2891 5.9378 10.4132 6.6552 10.46 7.37967H5.57ZM10.49 8.61967C10.4481 9.34471 10.324 10.0626 10.12 10.7597C8.74823 10.413 7.31177 10.413 5.94 10.7597C5.73687 10.0625 5.61275 9.34461 5.57 8.61967H10.49ZM10.89 3.61967C10.6361 3.05726 10.3385 2.51561 10 1.99967C10.7167 2.22188 11.3922 2.55966 12 2.99967C11.6431 3.2573 11.2612 3.47841 10.86 3.65967L10.89 3.61967ZM8.29 1.75967C8.8512 2.46088 9.31537 3.23451 9.67 4.05967C9.12203 4.18431 8.56196 4.24803 8 4.24967C7.438 4.2486 6.87787 4.18488 6.33 4.05967C6.68264 3.23349 7.14697 2.45961 7.71 1.75967H8.29ZM5.14 3.65967C4.73885 3.47841 4.35693 3.2573 4 2.99967C4.60777 2.55966 5.28333 2.22188 6 1.99967C5.66398 2.52601 5.37615 3.08159 5.14 3.65967ZM3 3.82967C3.53635 4.23922 4.12486 4.57551 4.75 4.82967C4.50768 5.65657 4.36335 6.50908 4.32 7.36967H1.32C1.46805 6.03491 2.05961 4.7884 3 3.82967ZM1.28 8.61967H4.28C4.32335 9.48025 4.46768 10.3328 4.71 11.1597C4.08486 11.4138 3.49635 11.7501 2.96 12.1597C2.01961 11.2009 1.42805 9.95443 1.28 8.61967ZM5.14 12.3397C5.37615 12.9177 5.66398 13.4733 6 13.9997C5.28333 13.7775 4.60777 13.4397 4 12.9997C4.35693 12.742 4.73885 12.5209 5.14 12.3397ZM7.71 14.2397C7.14697 13.5397 6.68264 12.7658 6.33 11.9397C7.42891 11.6862 8.57109 11.6862 9.67 11.9397C9.31804 12.7662 8.85366 13.5402 8.29 14.2397H7.71ZM10.86 12.3397C11.2784 12.5179 11.6772 12.7391 12.05 12.9997C11.4391 13.4346 10.7644 13.7719 10.05 13.9997C10.3641 13.469 10.635 12.9139 10.86 12.3397ZM13 12.1697C12.4637 11.7601 11.8751 11.4238 11.25 11.1697C11.4942 10.3432 11.6385 9.49046 11.68 8.62967H14.68C14.5319 9.96443 13.9404 11.2109 13 12.1697Z"
                    fill="currentColor"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_7142_149278">
                    <rect
                      width="16"
                      height="16"
                      fill="white"
                    />
                  </clipPath>
                </defs>
              </svg>
            </button>
          </section>
        </div>
        <div
          v-if="index > 0"
          class="absolute right-0 flex w-8 cursor-pointer items-center justify-center text-placeholder-gray hover:text-gray-over-dark"
          style="top: 30%"
          @click="removeField(index)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="19"
            viewBox="0 0 16 19"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.99134 2.65885C6.4132 2.237 6.98536 2 7.58196 2C8.17855 2 8.75071 2.237 9.17257 2.65885C9.34678 2.83306 9.48946 3.0329 9.59695 3.24951H5.56696C5.67445 3.0329 5.81714 2.83306 5.99134 2.65885ZM3.4518 3.24951C3.63409 2.49669 4.02039 1.80138 4.57713 1.24464C5.37406 0.447711 6.45493 0 7.58196 0C8.70898 0 9.78985 0.447709 10.5868 1.24464C11.1435 1.80138 11.5298 2.49669 11.7121 3.24951H11.9363L11.9552 3.2496H15.1642V5.2496H13.9363C13.9363 5.28895 13.9351 5.32854 13.9327 5.36835L13.2781 16.3662C13.2152 17.4228 12.3401 18.2474 11.2816 18.2474H3.88195C2.82353 18.2474 1.94837 17.4228 1.88548 16.3662L1.23084 5.36835C1.22847 5.32854 1.22728 5.28895 1.22724 5.2496H0V3.2496H3.20835L3.22731 3.24951H3.4518ZM3.88194 16.2474L3.22731 5.2496H11.9363L11.2816 16.2474H3.88194ZM4.68652 14.336L4.68652 6.75391H6.68652L6.68652 14.336H4.68652ZM8.47754 6.75391V14.336H10.4775V6.75391H8.47754Z"
              fill="currentColor"
            />
          </svg>
        </div>
      </div>
    </transition-group>
    <button
      class="mt-2 flex w-full items-center justify-center gap-2 rounded-md border p-2"
      :class="[
        canAddAnother
          ? 'border-gray-over-dark text-gray-over-dark'
          : 'cursor-not-allowed border-light-gray text-light-gray',
      ]"
      @click="addField"
    >
      <span class="text-sm">Add Another</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="13"
        height="14"
        viewBox="0 0 13 14"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.49871 6L0.433593 6L0.433595 8L5.49871 8L5.49871 13.0645L7.49871 13.0645L7.4987 8L12.5632 8V6L7.4987 6L7.4987 0.934889L5.4987 0.934889L5.49871 6Z"
          fill="currentColor"
        />
      </svg>
    </button>
  </section>
</template>

<script setup>
import { ref, computed, defineProps, defineEmits, watch } from 'vue';
import { isDomain, isEmail, isPhone } from '@/common/validators.js';

const props = defineProps({
  emailOrDomain: {
    type: Boolean,
    default: false,
    required: false,
  },
  dataStored: {
    type: Array,
    default: () => [],
    required: false,
  },
});

const emit = defineEmits(['update:fields', 'delete']);

const fields = ref(JSON.parse(JSON.stringify(props.dataStored)));

const addField = () => {
  if (!canAddAnother.value) return;

  fields.value.push({
    type: props.emailOrDomain ? 'email' : 'phone',
    value: '',
  });
};

const removeField = (index) => {
  if (fields.value[index]?.id) emit('delete', fields.value[index]);
  fields.value.splice(index, 1);
};

const updateType = (index, newType) => {
  if (props.emailOrDomain) {
    fields.value[index].type = newType;
  }
};

const getInputType = (type) => {
  switch (type) {
    case 'email':
      return 'email';
    case 'phone':
      return 'tel';
    case 'domain':
      return 'text';
  }
};

const canAddAnother = computed(() => {
  const firstField = fields.value?.[0];
  if (!firstField?.value) return false;

  if (firstField.type === 'email') {
    return isEmail(firstField.value);
  } else if (firstField.type === 'domain') {
    return isDomain(firstField.value);
  } else {
    return isPhone(firstField.value);
  }
});

const getPlaceholder = (type) => {
  if (type === 'email') {
    return 'Enter rate confirmation email';
  } else if (type === 'domain') {
    return 'Enter rate confirmation domain (ex. abclogistics.com)';
  } else {
    return 'Enter phone number';
  }
};

const categorizeFields = (fields) => {
  const categorizedFields = {
    email: [],
    phone: [],
    domain: [],
  };
  fields.forEach((field) => {
    categorizedFields[field.type].push(field);
  });

  return categorizedFields;
};

watch(
  fields,
  (newFields) => {
    emit('update:fields', categorizeFields(newFields));
  },
  { deep: true }
);

watch(
  () => props.dataStored,
  (data) => {
    if (fields.value.length === 0) {
      fields.value = JSON.parse(JSON.stringify(data));
    }
  },
  { immediate: true }
);
</script>
<style scoped>
.list-enter-active {
  transition: all 0.5s ease;
}

.list-leave-active {
  transition: all 0.3s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}
</style>
